export default __webpack_public_path__ + "static/media/bg_daily_points.6b5e0732.png";